import { FunctionComponent as F, useState } from "react";
import { TableRow, TableCell, Table, TableHead, TableBody, Link } from "@mui/material";
import { handleToggleSortValues } from "../../utils/table";
import HeadingSort from "../UI/Table/HeadingSort";
import { alphabeticalSort, sToTimestamp, timestampToSeconds } from "../../utils/string";
import { IValue } from "./RefsTable";
import TextTooltipOpt from "../UI/Tooltip/TextTooltipOpt";
import { SortDirection, SortFn } from "../../core/types/component";


interface IProps
{
  record: IValue,
  showInverseTimestamps?: boolean,
  onTimestampClick?: (timestamp: string) => void,
  timestampTooltip?: (timestamp: string) => string
}


const SpielsTable: F<IProps> = (props: IProps) =>
{
  const showInverseTimestamps = (props.showInverseTimestamps !== undefined) ?
    props.showInverseTimestamps && props.record.postLength :
    false;

  const [values, setValues] = useState(props.record.spiels.map(s => showInverseTimestamps ? {
    timestamp: s.timestamp,
    inverseTimestamp: sToTimestamp(
      timestampToSeconds(String(props.record.postLength)) -
      timestampToSeconds(s.timestamp)),
    nRefsInSpiel: s.refs.length } : { timestamp: s.timestamp, nRefsInSpiel: s.refs.length })
    .sort((a, b) => alphabeticalSort(a.timestamp, b.timestamp)));


  // Sorting
  const [timestampSort, setTimestampSort] = useState<SortDirection | null>(SortDirection.ascending);
  const [mentionsSort, setMentionsSort] = useState<SortDirection | null>(null);
  const [inverseMentionsSort, setInverseMentionsSort] = useState<SortDirection | null>(null);
  const allSetSorts = [setTimestampSort, setMentionsSort, setInverseMentionsSort];

  const handleToggleSort = (
    key: string,
    sort: SortDirection | null,
    setSort: (value: React.SetStateAction<SortDirection | null>) => void,
    sortFn?: SortFn) =>
    handleToggleSortValues<{ timestamp: string, inverseTimestamp?: string, nRefsInSpiel: number }>({
      values,
      setValues,
      key,
      sortDirection: sort,
      setSortDirection: setSort,
      unsetSortDirections: allSetSorts,
      sortFn });

  return (
    <Table size='small' padding='checkbox'>
      <TableHead>
        <TableRow key={0}>
          <TableCell key={0}>
            <HeadingSort
              headingText={"Timestamp"}
              sort={timestampSort}
              handleToggleSort={handleToggleSort(
                'timestamp',
                timestampSort,
                setTimestampSort,
                alphabeticalSort)} />
          </TableCell>
          {showInverseTimestamps ?
            <TableCell key={1}>
              <HeadingSort
                headingText={"Inverse Timestamp"}
                sort={inverseMentionsSort}
                handleToggleSort={handleToggleSort(
                  'inverseTimestamp',
                  inverseMentionsSort,
                  setInverseMentionsSort,
                  alphabeticalSort)} />
            </TableCell> :
            <></>}
          <TableCell key={2}>
            <HeadingSort
              headingText={"Mentions"}
              sort={mentionsSort}
              handleToggleSort={handleToggleSort(
                'nRefsInSpiel',
                mentionsSort,
                setMentionsSort)} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {values.map((s, i) =>
          <TableRow key={i}>
            {Object.entries(s).map((e, j) =>
            {
              return(
                <TableCell key={j}>
                  {(e[0] === "timestamp" && props.onTimestampClick) ?
                    <TextTooltipOpt
                      showtooltip={Boolean(props.timestampTooltip)}
                      lines={[props.timestampTooltip ? props.timestampTooltip(e[1]) : ""]}>
                      <Link
                        onClick={() => (props.onTimestampClick as (timestamp: string) => void)(e[1])}
                        style={{ cursor: 'pointer' }} >
                        {e[1]}
                      </Link>
                    </TextTooltipOpt> :
                    e[1]}
                </TableCell>)
            })}
          </TableRow>)}
      </TableBody>
    </Table>);
};

export default SpielsTable;
